import {
	epk_1,
	epk_2,
	epk_3,
	epk_4,
	epk_5,
	epk_6,
	epk_7,
	epk_8,
	epk_9,
} from '../assets/images/epk/images.js';

const options_epk = [
	{
		title: 'Как создать новую похозяйственную книгу',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Похозяйственные книги» в левом боковом меню.',
					'3. Нажмите на кнопку «Создать книгу».',
				],
				image: epk_1.epk_1_1,
			},
			{
				text: [
					'4. Добавьте населенный пункт для этого нажмите на кнопку «Добавить».',
				],
				image: epk_1.epk_1_2,
			},
			{
				text: [
					'5. Выберите код ОКТМО и населенный пункт и нажмите кнопку «Выбрать».',
				],
				image: epk_1.epk_1_3,
			},
			{
				text: ['6. Нажмите на кнопку «Сохранить» в правом верхнем углу.'],
				image: epk_1.epk_1_4,
			},
			{
				text: [
					'7. Новая похозяйственная книга создана. В общих сведениях в поле «Номер похозяйственной книги №» автоматически будет присвоен номер.',
				],
				image: epk_1.epk_1_5,
			},
			{
				text: [
					'8. Оформите нормативно-правовой акт о закладке новой похозяйственной книги используя номер созданной похозяйственной книги.',
				],
				image: epk_1.epk_1_6,
			},
			{
				text: [
					'9. Отсканируйте нормативно-правовой акт.',
					'10. Нажмите на кнопку «Редактировать» в правом верхнем углу в форме созданной похозяйственной книги.',
				],
				image: epk_1.epk_1_7,
			},
			{
				text: [
					'11. Заполните наименование, номер и дату нормативно-правового акта.',
				],
				image: epk_1.epk_1_8,
			},
			{
				text: [
					'12. Нажмите на кнопку «Добавить документ» и выберите скан-копию нормативно-правового акта.',
				],
				image: epk_1.epk_1_9,
			},
			{
				text: [
					'13. Нажмите на кнопку «Сохранить». Похозяйственная книга создана',
				],
			},
		],
	},
	{
		title: 'Как загрузить исторические данные похозяйственных книг',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Похозяйственные книги» в левом боковом меню.',
					'3. Нажмите на кнопку «Загрузить исторические данные» в правом верхнем углу.',
				],
				image: epk_2.epk_2_1,
			},
			{
				text: [
					'4. Выберите файл, содержащий сведения о заложенных похозяйственных книгах в формате .json/.csv/.xlsx.',
					'5. Нажмите на кнопку «Открыть». ',
				],
				image: epk_2.epk_2_2,
			},
			{
				text: ['6. Исторические данные загружены.'],
			},
		],
	},
	{
		title: 'Как сформировать сводную похозяйственную книгу за 1 год',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Похозяйственные книги» в левом боковом меню.',
					'3. Перейдите в Похозяйственную книгу, свод по которой хотите создать.',
				],
				image: epk_3.epk_3_1,
			},
			{
				text: ['4. Перейдите в раздел “Своды”.'],
				image: epk_3.epk_3_2,
			},
			{
				text: [
					'5. Нажмите кнопку “Сформировать сводную похозяйственную книгу”.',
				],
				image: epk_3.epk_3_3,
			},
			{
				text: ['6. Из списка выберите книгу, по которой нужно создать свод.'],
				image: epk_3.epk_3_4,
			},
			{
				text: ['7. Нажмите кнопку “Продолжить”.'],
				image: epk_3.epk_3_5,
			},
			{
				text: [
					'8. Выберите из списка период , за который нужно сформировать свод.',
				],
				image: epk_3.epk_3_6,
			},
			{
				text: ['9. Нажмите продолжить.'],
				image: epk_3.epk_3_7,
			},
			{
				text: ['10. Сводная похозяйственная книга сформирована.'],
			},
		],
	},
	{
		title: 'Как обновить сформированную сводную похозяйственную книгу за 1 год',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Похозяйственные книги» в левом боковом меню.',
					'3. Перейдите в Похозяйственную книгу, свод по которой хотите обновить.',
				],
				image: epk_4.epk_4_1,
			},
			{
				text: ['4. Перейдите в раздел “Своды”.'],
				image: epk_4.epk_4_2,
			},
			{
				text: [
					'5. Выберите ранее сформированную сводную похозяйственную книгу.',
				],
				image: epk_4.epk_4_3,
			},
			{
				text: ['6. В верхней части нажмите кнопку рефреша.'],
				image: epk_4.epk_4_4,
			},
			{
				text: ['7. Вы обновили сводную похозяйственную книгу.'],
			},
		],
	},
	{
		title: 'Как сформировать выписку по форме похозяйственной книги',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Выписки» в левом боковом меню.',
				],
				image: epk_5.epk_5_1,
			},
			{
				text: ['3. Нажмите на кнопку «Сформировать выписку».'],
				image: epk_5.epk_5_2,
			},
			{
				text: [
					'4. Выберите тип выписки «По форме книги».',
					'5. Нажмите на кнопку «Выбрать».',
				],
				image: epk_5.epk_5_3,
			},
			{
				text: ['6. Выберите главу ЛПХ.', '7. Нажмите кнопку “Продолжить”.'],
				image: epk_5.epk_5_4,
			},
			{
				text: [
					'8. Заполните все необходимые поля в появившемся окне формы (прокрутите вниз чтобы увидеть все поля).',
				],
				image: epk_5.epk_5_5,
			},
			{
				text: ['9. Нажмите на кнопку «Создать».'],
				image: epk_5.epk_5_6,
			},
			{
				text: [
					'10. Выписка создана. Разделы для просмотра отображены в левом боковом меню. ',
				],
				image: epk_5.epk_5_7,
			},
		],
	},
	{
		title: 'Как подписать выписку',
		instructions: [
			{
				text: ['1. Нажмите на кнопку «Утвердить» в правом верхнем углу. '],
				image: epk_6.epk_6_1,
			},
			{
				text: ['2. Нажмите кнопку «Подписать отчет».'],
				image: epk_6.epk_6_2,
			},
			{
				text: [
					'3. Введите пароль от сертификата.',
					'4. Нажмите на кнопку «ОК».',
				],
			},
		],
	},
	{
		title: 'Как скачать печатную форму выписки',
		instructions: [
			{
				text: ['1. Нажмите на кнопку «Скачать выписку» в правом верхнем углу.'],
				image: epk_7.epk_7_1,
			},
			{
				text: [
					'2. Печатная форма выписки была скачана на ваш локальный компьютер.',
				],
			},
		],
	},
	{
		title: 'Как сформировать выписку в произвольной форме',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Выписки» в левом боковом меню.',
				],
				image: epk_8.epk_8_1,
			},
			{
				text: ['3. Нажмите на кнопку «Сформировать выписку».'],
				image: epk_8.epk_8_2,
			},
			{
				text: [
					'4. Выберите тип выписки «В произвольной форме».',
					'5. Нажмите на кнопку «Выбрать».',
				],
				image: epk_8.epk_8_3,
			},
			{
				text: ['6. Выберите главу ЛПХ.', '7. Нажмите кнопку “Продолжить”.'],
				image: epk_8.epk_8_4,
			},
			{
				text: [
					'8. Заполните все необходимые поля в появившемся окне формы (прокрутите вниз чтобы увидеть все поля).',
				],
				image: epk_8.epk_8_5,
			},
			{
				text: ['9. Нажмите на кнопку «Создать».'],
				image: epk_8.epk_8_6,
			},
			{
				text: [
					'10. Выписка создана. Разделы для просмотра отображены в левом боковом меню.',
				],
				image: epk_8.epk_8_7,
			},
		],
	},
	{
		title:
			'Как сформировать выписку о наличии у гражданина права на земельный участок (Выписка НПЗУ)',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Выписки» в левом боковом меню.',
				],
				image: epk_9.epk_9_1,
			},
			{
				text: ['3. Нажмите на кнопку «Сформировать выписку».'],
				image: epk_9.epk_9_2,
			},
			{
				text: [
					'4. Выберите тип выписки «О наличии права».',
					'5. Нажмите на кнопку «Выбрать».',
				],
				image: epk_9.epk_9_3,
			},
			{
				text: ['6. Выберите главу ЛПХ.', '7. Нажмите кнопку “Продолжить”.'],
				image: epk_9.epk_9_4,
			},
			{
				text: [
					'8. Заполните все необходимые поля в появившемся окне формы (прокрутите вниз чтобы увидеть все поля).',
				],
				image: epk_9.epk_9_5,
			},
			{
				text: ['9. Нажмите на кнопку «Создать».'],
				image: epk_9.epk_9_6,
			},
			{
				text: ['10. Выписка НПЗУ создана'],
			},
		],
	},
];

export default options_epk;
